
import AppConsts from './appconst'
import Util from './util'
import * as signalR from "@aspnet/signalr";
import { EventBus } from '@/lib/eventbus';
import Url from "./url";
//import { SignalViewModel } from "./signal-view-model";

export default class SignalRService {
  private hubConnection: signalR.HubConnection;
  private encryptedAuthToken = Util.abp.utils.getCookieValue(AppConsts.authorization.encrptedAuthTokenName);

  constructor() {
    this.buildConnection();
    this.startConnection();
  }

  private buildConnection = () => {
    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(Url+"signalr-notifyHub?"+AppConsts.authorization.encrptedAuthTokenName + "=" + encodeURIComponent(this.encryptedAuthToken))
      .build();
  };
  setProgress(message: any) {
    //this.hubConnection.invoke('SendProgress', message);
  }
  private startConnection = () => {
    this.hubConnection
      .start()
      .then(() => {
        //console.log("Connection Started...");
        this.registerSignalEvents();
      })
      .catch(err => {
        console.log("Error while starting connection: " + err);

        //if you get error try to start connection again after 3 seconds.
        setTimeout(function () {
          this.startConnection();
        }, 3000);
      });
  }

  private registerSignalEvents() {
    this.hubConnection.on("SendProgress", (data: any) => {
      //@ts-ignore
      EventBus.$emit("sendProgress" ,data);
    });
  }
}
